<script>
import {mapActions, mapGetters} from "vuex";
import {useMobileMenu} from "@/mixins/useMobileMenu";
import MobileCommunePartnerDisplay from "@/components/navigation/private/MobileCommunePartnerDisplay.vue";

export default {
  name: "SubServiceColumn",
  components: {MobileCommunePartnerDisplay},
  computed: {
    ...mapGetters('navigation', ['getSubServices', 'getNavTitle']),
    sortedSubServices() {
      return [...this.getSubServices].sort((item1, item2) => item1.title.localeCompare(item2.title));
    },
    columnStyle() {
      if(this.useMobileMenu) return {
        paddingTop: '16px'
      };
      return {
        paddingTop: '105px',
        width: '380px',
        height: '100vh',
      };
    }
  },
  mixins: [useMobileMenu],
  methods: {
    ...mapActions('navigation', ['setSelectedServiceAreaId', 'setSelectedServiceId']),
    onClick() {
      this.setSelectedServiceAreaId(null);
      console.log("SubServiceColumn clicked, resetting selected service area");
    },
    onTitleClick() {
      this.setSelectedServiceId(null);
    }
  }
}
</script>

<template>
<div id="subservice-column" :style="columnStyle">
  <v-list style="background: transparent;" v-if="useMobileMenu">
  <v-list-item  style="cursor: pointer" class="menu-item" @click="onTitleClick">
    <v-list-item-content :class="{'nav-item-border' : useMobileMenu}">
      <div class="d-flex align-center nav-title">
        <v-icon left>mdi-chevron-left</v-icon>
        {{ getNavTitle }}
      </div>
    </v-list-item-content>
  </v-list-item>
  </v-list>
  <v-list class="subservice-list" style="background: transparent">
    <v-list-item class="sub-service-item" v-for="subService of sortedSubServices" :key="subService.id" :class="{'nav-item-border' : useMobileMenu}" style="cursor: pointer; background: unset" :to="subService.link" @click="onClick">
      <v-list-item-content class="sub-menu-item">
        <div class="d-flex align-center sub-menu-font-size">
          {{ subService.title }}
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <mobile-commune-partner-display v-if="useMobileMenu" />
</div>
</template>

<style scoped>
#subservice-column {
  background: #F2F2F3;
}

.subservice-list {
  height: auto;
}

@media (min-width: 1264px) {
  .subservice-list {
    height: calc(100vh - 105px);
    overflow-y: auto;
  }
}

.sub-service-item:hover {
  text-decoration: none !important;
  font-weight: bold;
}
</style>
